import {
  Component,
  input,
  InputSignal,
  OnInit,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import {
  ControlContainer,
  FormGroupDirective,
  NgControl,
} from '@angular/forms';
import { FormInputComponent } from '../form-input.component';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';

@Component({
  selector: 'aw-toggle',
  imports: [CommonModule, ErrorMessageComponent, AppendTestIdPipe],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './toggle.component.html',
})
export class ToggleComponent extends FormInputComponent implements OnInit {
  public showLabelLeft: InputSignal<boolean> = input(false);
  public readonly activeValue: InputSignal<unknown> = input<unknown>(true);
  public readonly inactiveValue: InputSignal<unknown> = input<unknown>(false);

  public readonly valueChange: OutputEmitterRef<boolean> = output<boolean>();
  public readonly isPressed: WritableSignal<boolean> = signal(false);

  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
    this.subscription.add(
      this.ngControl.control!.valueChanges.subscribe(value => {
        this.ngControl.control!.markAsTouched();
        this.valueChange.emit(this.isActive(value));
      })
    );
  }

  /*
   * Necessary so clicking the label also change the controls value
   * touched needs to be set too, since type=checkbox does not propagate it by itself
   * */
  public toggle(e: Event): void {
    e.preventDefault();
    if (this.ngControl.control && !this.ngControl.control.disabled) {
      this.ngControl.control.setValue(
        this.isActive() ? this.inactiveValue() : this.activeValue()
      );
      this.ngControl.control?.markAsTouched();
      this.ngControl.control?.markAsDirty();
    }
    this.endPress();
  }

  public isActive(value: unknown = this.ngControl.control?.value): boolean {
    return value === this.activeValue();
  }

  public startPress(event: PointerEvent): void {
    if (event.button === 0 && !this.ngControl.control?.disabled) {
      this.isPressed.set(true);
    }
  }

  public endPress(): void {
    this.isPressed.set(false);
  }
}
